import React from 'react'
import ScrollSpy from '../../../layouts/scrollspy'
import ListingBadge, { BADGE_MODE } from './base'
import {
  isTPSLive,
  isTPSOnline,
  isFCLMarketing,
  hasADCAuctioneer,
} from './utils'

class ConductedByADCOnlineBadge extends ListingBadge {
  static title = 'Conducted by Auction.com'

  static titleIcon = 'gavel'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return badgeMode === BADGE_MODE.EXPANDED && isTPSOnline(listing)
  }

  get content() {
    return (
      <>
        This is an online auction conducted by Auction.com.
        <ScrollSpy selector='#faqs'>
          {({ scrollTo }) => <a onClick={scrollTo}> Learn More.</a>}
        </ScrollSpy>
      </>
    )
  }
}

class ConductedByADCLiveBadge extends ConductedByADCOnlineBadge {
  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      isTPSLive(listing) &&
      hasADCAuctioneer(listing)
    )
  }

  get content() {
    return (
      <>
        Auction.com will conduct the sale in person.{' '}
        <a
          href='https://auction.onelink.me/WqvL/7185fc99'
          target='_blank'
          rel='noreferrer'
        >
          Download the app
        </a>{' '}
        for real time updates and time-saving benefits.
      </>
    )
  }
}

class NotConductedByADCLive extends ConductedByADCOnlineBadge {
  static summary = 'No'

  static contentPositive = false

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      isTPSLive(listing) &&
      !hasADCAuctioneer(listing)
    )
  }

  get content() {
    return (
      <>
        This in-person auction will be conducted by a third party at a county
        location.
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => <a onClick={scrollTo}> Learn More.</a>}
        </ScrollSpy>
      </>
    )
  }
}

class NotConductedByADCFCLBadge extends ConductedByADCOnlineBadge {
  static summary = 'No'

  static contentPositive = false

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return badgeMode === BADGE_MODE.EXPANDED && isFCLMarketing(listing)
  }

  get content() {
    return (
      <>
        This is an online auction conducted by a third party at the county
        website.{' '}
        <a onClick={e => this.emitEvent('bid_at_county_site', e)}>Learn More</a>
        {/* <BidAtCountySite venueUrl={biddingStatus.venueUrl}>
          <a>Learn More</a>
        </BidAtCountySite> */}
      </>
    )
  }
}

export {
  NotConductedByADCFCLBadge,
  ConductedByADCOnlineBadge,
  ConductedByADCLiveBadge,
  NotConductedByADCLive,
}
